import { eventsList } from '../../events/list';
import { initPolling } from '../../services/polling';
import { initResumable } from '../../services/resumable';
import { CorrelationId } from '../../utils/CorrelationId';
import { initHttp } from '../../utils/http';
import { extendDeep, get } from '../../utils/utils';
import { addEvents } from '../decorators';
import { initFolder } from './folder';
import { initFolders } from './folders';
import { initFoldersTrash } from './folders.trash';
import { initItem } from './item';
import { initItems } from './items';
import { initItemsTrash } from './items.trash';
import { toFolder } from './mappers/folder';
import { toItem } from './mappers/item';
import { initRefreshTokenWrapper } from './refresh-token-wrapper';
import { defaultSettings } from './settings';
import { initSocket } from './socket';
import { initTrash } from './trash';
import { initUser } from './user';
export function PrivateSite(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  if (!userSettings.siteMediaToken) {
    throw new Error('siteMediaToken param is missing');
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep({
    requestOptions: {
      params: {
        site_token: userSettings.siteMediaToken
      }
    }
  }, defaultSettings, userSettings);
  const withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
  const requestOptions = settings.requestOptions;
  if (get(requestOptions, 'params.ns')) {
    settings.ns = requestOptions.params.ns;
  }
  const channel = initSocket(settings, this);
  const correlationId = new CorrelationId();
  const http = initHttp(requestOptions);
  const polling = initPolling(settings, this, toItem, http, {
    path: '/site/media/files'
  });
  const resumable = initResumable(settings, this, toItem, http);
  const settingsWithRefreshToken = {
    get: withRefreshToken(http.get),
    post: withRefreshToken(http.post),
    upload: withRefreshToken(http.upload)
  };
  const httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;
  const trashSettings = {
    ...settings,
    sourceName: 'trash'
  };
  const folders = initFolders(settings, httpWithRefreshToken);
  const foldersTrash = initFoldersTrash(trashSettings, httpWithRefreshToken);
  const folder = initFolder(settings, httpWithRefreshToken);
  const items = initItems(settings, httpWithRefreshToken);
  const itemsTrash = initItemsTrash(trashSettings, httpWithRefreshToken);
  const item = initItem(settings, httpWithRefreshToken, channel, polling, resumable);
  const trash = initTrash(trashSettings, httpWithRefreshToken);
  const user = initUser(settings, httpWithRefreshToken);
  folders.trash = foldersTrash;
  items.trash = itemsTrash;
  this.name = settings.name || 'private-site';
  this.correlationId = correlationId;
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.folder = addEvents(this, eventsList.FOLDER, folder);
  this.item = addEvents(this, eventsList.ITEM, item);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.trash = addEvents(this, eventsList.TRASH, trash);
  this.user = addEvents(this, eventsList.USER, user);
  this.toItem = data => toItem(data, settings, settings.thumbnailSizes);
  this.toFolder = data => toFolder(data, settings);
}